import { warn } from 'helper/debug';

const win: any = window;

export const DATA_LAYER_REF = 'dataLayer';

export const ensureDataLayer = () => {
	if (!win) {
		warn('DataLayer: No window object found to register, skipping ...');
	}

	if (!win[DATA_LAYER_REF] || !Array.isArray(win[DATA_LAYER_REF])) {
		win[DATA_LAYER_REF] = [];
	}
};

ensureDataLayer();

export const get = (): any[] => win[DATA_LAYER_REF];
export const push = (data: any): number | void => {
	if (process.env.REACT_APP_DEBUG_GA === 'true') {
		return console.log(data);
	}
	return win[DATA_LAYER_REF].push(data);
};
export const flush = (): any[] => (win[DATA_LAYER_REF] = []);
export const findByIndex = (index: number): any => win[DATA_LAYER_REF][index] || {};
export const getVirtualPageTitle = (): string => win.document.title || '';
export const getPageGroupCategoryFromVirtualPageUrl = (virtualPageUrl: string) =>
	virtualPageUrl.split('/').filter((path: string) => Boolean(path.length > 0)) || [];
export const getVirtualPageUrl = (manualUrlAddition: string = ''): string => {
	const href = win.location.href;
	const host = win.location.origin;

	if (href && host) {
		return href.replace(`${host}/${manualUrlAddition}`, '');
	}

	return 'unknown';
};

export default {
	get,
	push,
	flush,
	findByIndex,
	ensureDataLayer,
	getVirtualPageUrl,
};
